











































































































import {Component, Prop, Vue} from "vue-property-decorator"
import axios, {AxiosResponse} from "axios";
import ModalAddDomains from "@/components/ModalAddDomains.vue";
import ModalChangeDomains from "@/components/ModalChangeDomains.vue";
import AuthApi from "@/api/AuthApi";

@Component({
  components: {
    ModalAddDomains,
    ModalChangeDomains
  }
})
export default class Domains extends Vue{
  public dialog: boolean = false
  public dialogDelete: boolean = false
  public dialogDeleteId!:number
  public dialogDeleteLoading: boolean = false
  public loadingData: boolean = true
  public search: string = ''
  public headers: any = [
    { text: 'Название', value: 'domains' },
    { text: 'Цена', value: 'price' },
    { text: 'Дата окончания', value: 'paidDate' },
    { text: 'Осталось (дн.)', value: 'paidDay' },
    { text: 'Действия', value: 'actions', sortable: false },
  ]
  public ServerDomains: any = []
  public domains: any = []

  public showChange: boolean = false
  public domainId: string = ''
  public domainName: string = ''
  public domainsHostingURL: string = ''
  public domainHostingLogin: string = ''
  public domainHostingPass: string = ''
  public domainsRegisterURL: string = ''
  public domainRegisterLogin: string = ''
  public domainRegisterPass: string = ''
  public domainPrice: string = ''
  public domainDate: string = ''
  public domainsHostingService: boolean = true
  public domainsRegisterService: boolean = true

  created(){
    (window as any).domains = this
  }

  openAddDomains(){
    (window as any).modalAdd.show()
  }

  showDeleteModal(id: number){
    this.dialogDeleteId = id
    console.log(id)
    this.dialogDelete = true
  }
  async successDeleteDomains(id: string){
    if (id != ''){
      console.log(id)
      this.dialogDeleteLoading = true
      // @ts-ignore
      const store: any = JSON.parse(localStorage.getItem('session'))
      if (store.token) {
        await axios.delete(AuthApi.API_URL + '/api/domains', {
          headers: {
            'authorization': 'Bearer ' + store.token
          },
          data: {
            id: id
          }
        })
            .then(res => {
              if (res.data.status) {
                this.dialogDeleteLoading = false
                this.dialogDelete = false
                this.domains = []
                this.getDomains()
                alert('Домен успешно удален')
              } else {
                alert(res.data.message)
                console.log(res.data)
                this.dialogDeleteLoading = true
              }
            })
      }
    }
  }

  mounted(){
    this.getDomains()
  }

  async getDomains(){
    this.loadingData = true
    // @ts-ignore
    const store: any = JSON.parse(localStorage.getItem('session'))
    if (store.token){
      await axios.get(AuthApi.API_URL + '/api/domains', {
        headers: {
          'authorization': 'Bearer ' + store.token
        }
      })
      .then(res => {
        if (res.data.status){
          this.loadingData = false
          this.ServerDomains = res.data.result
          this.convertDomains()
        } else {
          alert(res.data.message)
          localStorage.removeItem('session')
          this.$router.push('/login')
        }
      })
      .catch(e => {
        localStorage.removeItem('session')
        this.$router.push('/login')
      })
    }
  }


  showChangeModal(id: string){
    const domain = this.ServerDomains.filter((item: any) => item.id == id)[0]
    if (domain != undefined){
      this.domainId = domain.id;
      this.domainName = domain.domain;
      this.domainsHostingURL = domain.hostUrl;
      this.domainHostingLogin = domain.hostLogin;
      this.domainHostingPass = domain.hostPass;
      this.domainsRegisterURL = domain.domainUrl;
      this.domainRegisterLogin = domain.domainLogin;
      this.domainRegisterPass = domain.domainPass;
      this.domainPrice = domain.price;
      this.domainDate = domain.paidDate;
      this.domainsHostingService = domain.serviceHost;
      this.domainsRegisterService = domain.serviceDomain;
      (window as any).modalChange.show();
    }
  }

  convertDomains(){
    this.ServerDomains.forEach((item: any) => {
      this.domains.push({
        id: item.id,
        domains: item.domain,
        price: item.price,
        paidDate: new Date(item.paidDate).toLocaleDateString(),
        paidDay: this.getNumberOfDays(new Date(item.paidDate)),
      })
    })
    this.$forceUpdate()
  }

  getColor(item: any){
    if (item < 30) return 'red'
    else if (item < 60) return 'orange'
    else return 'green'
  }

  getNumberOfDays(end: any) {
    const date1 = new Date();
    const date2 = new Date(end);
    const oneDay = 1000 * 60 * 60 * 24;
    const diffInTime = date2.getTime() - date1.getTime();
    return Math.round(diffInTime / oneDay);
  }
}

